import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { Add } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { SnackAlertContext } from "../../../../context/SnackAlertContext";
import { AuthContext } from "../../../../context/AuthContext";
import CreateEmployeeForCompanyDialog from "../../Customers/CreateEmployeeForCompanyDialog";

const filter = createFilterOptions();

const SelectMultipleCompanyEmployee = ({
  companyId,
  excludeUserIds,
  value,
  label = "User",
  onUpdate,
  disabled,
  enableAdd,
  onBlur,
  error,
  helperText,
  required,
  ...props
}) => {
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { ezorder, authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [employees, setEmployees] = useState([]);
  const [open, toggleOpen] = useState(false);
  const [dialogValue, setDialogValue] = useState("");

  const getCompanyEmployees = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(
        `/company/${companyId}/users?status=ACTIVE`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      if (response.status == 200 || response.status == 201) {
        setEmployees(response.data.employees);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDialogValue("");
    toggleOpen(false);
  };

  useEffect(() => {
    if (disabled || !companyId) {
      setEmployees([]);
    } else {
      getCompanyEmployees();
    }
  }, [disabled, companyId]);

  return (
    <>
      <Autocomplete
        multiple
        freeSolo
        selectOnFocus
        clearOnBlur
        value={value}
        disabled={disabled}
        handleHomeEndKeys
        onChange={(event, newValue) => {
          console.log("newValue", newValue);
          // When the user types then presses "enter" key
          if (enableAdd && typeof newValue === "string") {
            console.log("if 1");
            // timeout to avoid instant validation of the dialog's form.
            // console.log("Value is string");
            setTimeout(() => {
              toggleOpen(true);
              setDialogValue(newValue.fullName);
            });
          }
          // When User types then clicks 'Add "inputText"'
          else if (
            enableAdd &&
            newValue &&
            newValue.length > 0 && // New Value not empty
            !newValue[newValue.length - 1].id
          ) {
            console.log("else 1", enableAdd, newValue, !newValue.id);
            // console.log("Value isnt string but no id");
            toggleOpen(true);
            setDialogValue(newValue[newValue.length - 1].fullName);
          }
          // When User Selects and Option (Object) or Clicks the clear button (null)
          else {
            console.log("else 2");
            // console.log("Value is object or null", newValue);
            // console.log("SET VALUE", newValue);
            if (onUpdate) onUpdate(newValue ?? null);
          }
        }}
        onInputChange={() => {
          // console.log("onInputChange");
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (enableAdd && params.inputValue !== "") {
            filtered.push({
              id: undefined,
              fullName: params.inputValue,
            });
          }

          return filtered;
        }}
        options={employees}
        getOptionLabel={(option) => {
          //   console.log("Option", option);
          // for example value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.fullName;
        }}
        isOptionEqualToValue={(option, value) => {
          //  The "selected" prop on renderOption depends on this
          return value.fullName == option.fullName;
        }}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;

          if (option.id)
            return (
              <li key={key} {...optionProps}>
                {option.fullName}
              </li>
            );
          else
            return (
              <li key={key} {...optionProps}>
                <Add style={{ marginRight: 8 }} />

                {option.id ? option.fullName : `Add "${option.fullName}"`}
              </li>
            );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size={props.size ? props.size : "small"}
            label={label}
            sx={{
              width: "100%",
            }}
            variant="outlined" // filled, outlined, standard
            InputProps={{
              ...params.InputProps,
              onKeyDown: (e) => {
                if (!enableAdd && e.key === "Enter") {
                  e.stopPropagation();
                }
              },
              endAdornment: <>{params.InputProps.endAdornment}</>,
            }}
            onBlur={onBlur}
            error={error}
            helperText={helperText}
            required={required}
          />
        )}
      />

      <CreateEmployeeForCompanyDialog
        companyId={companyId}
        open={open}
        defaultFullName={dialogValue}
        handleClose={handleClose}
        onSuccess={async (newUser) => {
          // Refresh Data
          await getCompanyEmployees();
          // Set Created as Value
          onUpdate([...value, newUser]);
          // Close Dialog
          handleClose();
        }}
      />
    </>
  );
};

export default SelectMultipleCompanyEmployee;
